export default __webpack_public_path__ + "src/assests/die.wav";